import { Injectable, inject } from '@angular/core';
import { Job, JobsCollection } from '@dges/modules/portfolio/domain';
import { Observable } from 'rxjs';
import {
  Firestore,
  CollectionReference,
  DocumentReference,
  collection,
  collectionData,
  addDoc,
  doc,
  updateDoc,
  deleteDoc,
} from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root',
})
export class JobsCollectionService implements JobsCollection {
  private firestore = inject(Firestore);

  private jobsCollection = collection(
    this.firestore,
    'jobs',
  ) as CollectionReference<Job>;

  public getJobs(): Observable<Job[]> {
    return collectionData(this.jobsCollection, {
      idField: 'id',
    }) as Observable<Job[]>;
  }

  public addJob(job: Job): Promise<DocumentReference<Job>> {
    return addDoc(this.jobsCollection, job);
  }

  public editJob(job: Job): Promise<void> {
    return updateDoc(doc(this.jobsCollection, String(job.id)), { ...job });
  }

  public deleteJob(job: Job): Promise<void> {
    return deleteDoc(doc(this.jobsCollection, String(job.id)));
  }
}
